import { SettingValueModel } from '../informate';
import { SharedContentTypeModel } from './shared-content-type-model';

export class SharedContentModel {
    sharedContentId: string;
    sharedContentCategory: sharedContentCategory;
    sharedContentCategoryId: string;
    image: string;
    imageBlob: Blob;
    imageFileName: string;
    heading: string;
    subHeading: string;
    navigationText: string;
    navigationLink: string;
    sharedContentTypeId: string;
    sharedContentType: SharedContentTypeModel;
    imageLocation: number;
    date: string;
    language: SettingValueModel;
    isPurchase?: boolean;
    price?: string;
    method?: string;
}

export class sharedContentCategory {
    sharedContentCategoryId: string;
    key: string;
    name: string;
    fileRequired: boolean;
}
